module.exports = "/desktop-app/assets/img/wran.svg?2f95c255784ca1bb0eabc97e4e227c74";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/svg/wran.svg
// module id = JYWO
// module chunks = 1